import React from 'react';
import { Tag } from '@blueprintjs/core';
import './MentionBadge.css';

interface MentionBadgeProps {
  type: 'mindmap' | 'node' | 'user' | 'organization';
  label: string;
  id: string;
  onClick?: () => void;
}

/**
 * Display a mention badge in a message
 * Shows the entity type icon and label
 */
const MentionBadge: React.FC<MentionBadgeProps> = ({ type, label, id, onClick }) => {
  const getIcon = () => {
    switch (type) {
      case 'mindmap':
        return '🗺️';
      case 'node':
        return '📍';
      case 'user':
        return '👤';
      case 'organization':
        return '🏢';
      default:
        return '•';
    }
  };

  const getIntent = () => {
    switch (type) {
      case 'mindmap':
        return 'primary';
      case 'node':
        return 'success';
      case 'user':
        return 'warning';
      case 'organization':
        return 'none';
      default:
        return 'none';
    }
  };

  return (
    <Tag
      className="mention-badge"
      intent={getIntent() as any}
      interactive={!!onClick}
      onClick={onClick}
      title={`${type}: ${label}`}
    >
      <span className="mention-icon">{getIcon()}</span>
      <span className="mention-label">{label}</span>
    </Tag>
  );
};

export default MentionBadge;





